export default "__VITE_ASSET__BU8s3Es7__"